import styled from 'styled-components'
import { TeloLink } from '../routing/TeloLink'

const LinkNoStyle = styled(TeloLink)`
	text-decoration: none;
	color: inherit;
`

export default LinkNoStyle
